/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Participanturl1Inputs */

const en_entity_participanturl1 = /** @type {(inputs: Entity_Participanturl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participant URL`)
};

const de_entity_participanturl1 = /** @type {(inputs: Entity_Participanturl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnehmer-URL`)
};

/**
* | output |
* | --- |
* | "Participant URL" |
*
* @param {Entity_Participanturl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_participanturl1 = /** @type {((inputs?: Entity_Participanturl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Participanturl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_participanturl1(inputs)
	return de_entity_participanturl1(inputs)
});
export { entity_participanturl1 as "entity_participantUrl" }